module.exports = __webpack_public_path__ + "static/media/video-img.0998f1f2.jpg";